import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { IdentityAuthService } from '../../../../services/identity-auth/identity-auth.service';
import { Permissions } from '../../../../config/AppEnums';

@Injectable()
export class AuthRoleGuard implements CanActivate {
  constructor(public auth: IdentityAuthService, public router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    var self = this;
    const expectedPermissions: Array<Permissions> = route.data.expectedPermissions;
    if (this.auth.AppSettingsLoaded) {
      if (this.auth.isAuthenticated() && !this.auth.hasAnyPermissionsArr(expectedPermissions)) {
        this.router.navigate(['unauthorised'])
        return false;
      }
    }
    else {
      this.auth.appSettingsLoadedEvent.subscribe(item => {
        if (item != null)
          if (self.auth.isAuthenticated() && !self.auth.hasAnyPermissionsArr(expectedPermissions)) {
            if (!self.auth.userOrganisations || self.auth.userOrganisations.length == 0) {
              self.auth.userOrganisationsObserver.subscribe(o => {
                if (self.auth.userOrganisations.length > 0)
                  if (self.auth.isAuthenticated() && !self.auth.hasAnyPermissionsArr(expectedPermissions)) {
                    self.router.navigate(['unauthorised'])
                    return false;
                  }
              })
            } else {
              self.router.navigate(['unauthorised'])
              return false;
            }
          }
      });
    }
    return true;
  }


}
